"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var BrandsList_1 = require("./component/BrandsList");
var BrandEditor_1 = require("./component/BrandEditor");
var BrandOperationsAccess_1 = require("./component/BrandOperationsAccess");
var BrandOperationsConfig_1 = require("./component/BrandOperationsConfig");
var BrandSmtpCfgEditor_1 = require("./component/BrandSmtpCfgEditor");
var BrandLocalisations_1 = require("./component/BrandLocalisations");
var BrandSmsCfgEditor_1 = require("./component/BrandSmsCfgEditor");
var PUBrandsList = /** @class */ (function (_super) {
    __extends(PUBrandsList, _super);
    function PUBrandsList(props) {
        return _super.call(this, props) || this;
    }
    PUBrandsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({ page_size: data.tablePageSize });
        });
        this.SID_TAGS = this.props.listAppUsrPlayerTags.Subscribe("*", function (id, data) {
            _this.setState({ app_player_tags_avail: data.data });
        });
        this.SID_PROVIDERS = this.props.listSmsProvidersAvail.Subscribe("*", function (id, data) {
            _this.setState({ sms_providers_avail: data.data });
        });
        this.SID_SEGMENTS = this.props.ListBrandGwsGameZonesBehaviorTypesAvail.Subscribe("*", function (id, data) {
            _this.setState({ player_segmentation_avail: data.data });
        });
        this.SID_REGT = this.props.listBrandPlayerRegistrationTypesAvail.Subscribe("*", function (id, data) {
            _this.setState({ player_registration_avail: data.data });
        });
        this.SID_TZ = this.props.ListTrustZonesAvail.Subscribe("*", function (id, data) {
            _this.setState({ trust_zones_avail: data.data });
        });
        this.SID_ATZ = this.props.ListAppTrustZonesAvail.Subscribe("*", function (id, data) {
            _this.setState({ app_trust_zones: data.data });
        });
        this.SID_PA = this.props.ListBrandParsingActionsAvail.Subscribe("*", function (id, data) {
            _this.setState({ parsing_action_avail: data.data });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            app_player_tags_avail: [],
            page_size: this.props.state.getTablePageSize(),
            sms_providers_avail: [],
            player_segmentation_avail: [],
            trust_zones_avail: [],
            player_registration_avail: [],
            parsing_action_avail: [],
            app_trust_zones: []
        }, function () {
            _this.props.listAppUsrPlayerTags.LoadData();
            _this.props.listSmsProvidersAvail.LoadData();
            _this.props.ListBrandGwsGameZonesBehaviorTypesAvail.LoadData();
            _this.props.ListTrustZonesAvail.LoadData();
            _this.props.listBrandPlayerRegistrationTypesAvail.LoadData();
            _this.props.ListBrandParsingActionsAvail.LoadData();
            _this.props.ListAppTrustZonesAvail.LoadDataAsCodeVal();
        });
    };
    PUBrandsList.prototype.componentWillUnmount = function () {
        this.props.state.UnSubscribe(this.SID_STATE);
        this.props.listAppUsrPlayerTags.UnSubscribe(this.SID_TAGS);
        this.props.listSmsProvidersAvail.UnSubscribe(this.SID_PROVIDERS);
        this.props.ListBrandGwsGameZonesBehaviorTypesAvail.UnSubscribe(this.SID_SEGMENTS);
        this.props.ListTrustZonesAvail.UnSubscribe(this.SID_TZ);
        this.props.listBrandPlayerRegistrationTypesAvail.UnSubscribe(this.SID_REGT);
        this.props.ListBrandParsingActionsAvail.UnSubscribe(this.SID_PA);
        this.props.ListAppTrustZonesAvail.UnSubscribe(this.SID_ATZ);
    };
    PUBrandsList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PUBrandsList.prototype.onEditClick = function (val) {
        this.setState({ edit_mode: "EDIT", record: val });
    };
    PUBrandsList.prototype.onAccessConfigClick = function (val) {
        this.setState({ edit_mode: "ACCESS-CONFIG", record: val });
    };
    PUBrandsList.prototype.onGatewaysConfigClick = function (val) {
        this.setState({ edit_mode: "OPERATIONS-CONFIG", record: val });
    };
    PUBrandsList.prototype.onSMTPConfigClick = function (val) {
        this.setState({ edit_mode: "SMTP-CONFIG", record: val });
    };
    PUBrandsList.prototype.onSMSConfigClick = function (val) {
        this.setState({ edit_mode: "SMS-CONFIG", record: val });
    };
    PUBrandsList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PUBrandsList.prototype.onGoLocalesClick = function (val) {
        this.setState({ edit_mode: "LOCALES-LIST", record: val });
    };
    PUBrandsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PUBrandsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(BrandEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), app_usr_player_tags: this.state.app_player_tags_avail, dialogSelectImage: this.props.dialogSelectImage, ListBrandGwsGameZonesBehaviorTypesAvail: this.props.ListBrandGwsGameZonesBehaviorTypesAvail, player_segmentation_avail: this.state.player_segmentation_avail, player_registration_avail: this.state.player_registration_avail, player_on_parse_actions_avail: this.state.parsing_action_avail }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(BrandEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), app_usr_player_tags: this.state.app_player_tags_avail, dialogSelectImage: this.props.dialogSelectImage, ListBrandGwsGameZonesBehaviorTypesAvail: this.props.ListBrandGwsGameZonesBehaviorTypesAvail, player_segmentation_avail: this.state.player_segmentation_avail, player_registration_avail: this.state.player_registration_avail, player_on_parse_actions_avail: this.state.parsing_action_avail }));
        }
        if (this.state.edit_mode === "ACCESS-CONFIG") {
            return (React.createElement(BrandOperationsAccess_1.default, { dataAccess: this.props.access, dialog: this.props.dialog, onGoBackClick: this.onGoBackClick.bind(this), record: this.state.record, state: this.props.state }));
        }
        if (this.state.edit_mode === "OPERATIONS-CONFIG") {
            return (React.createElement(BrandOperationsConfig_1.default, { onGoBackClick: this.onGoBackClick.bind(this), record: this.state.record, state: this.props.state, brandAffilates: this.props.brandAffilates, listAffilatesAvail: this.props.listAffilates, listAvailAppLanguages: this.props.listAppLanguages, listAvailAppCurrency: this.props.listAppCurrency, listAvailAppCountries: this.props.listAppCountries, listGwsGameProviderAvail: this.props.listGwsGameProviders, brandGwsGameProvider: this.props.brandGwsGameProvider, brandAppCurrency: this.props.listBrandAppCurrency, brandAppLanguage: this.props.listBrandAppLanguage, brandAppCountry: this.props.listBrandAppCountry, brandAppPayouts: this.props.listbrandAppPayouts, listAvailAppPayouts: this.props.listAvailAppPayouts, listAvailEMailTemplateActions: this.props.listEMailTemplateActions, brandEmailTemplates: this.props.dataEmailTemplates, brandEmailTemplateImages: this.props.dataEmailTemplateImages, dialogSelectImage: this.props.dialogSelectImage, listForBrandStatPartnerOffersAvail: this.props.listForBrandStatPartnerOffersAvail, listForBrandStatPartnersAvail: this.props.listForBrandStatPartnersAvail, listForBrandStatPProgramsAvail: this.props.listForBrandStatPProgramsAvail, dialogViewText: this.props.dialogViewText, brandSmsTemplates: this.props.brandSmsTemplates, listSmsTemplateActions: this.props.listSmsTemplateActions, ListGwsGameProviderZonesAvail: this.props.ListGwsGameProviderZonesAvail, ListPlayerBehaviorTypesAvail: this.props.ListPlayerBehaviorTypesAvail, ListTresholdBehaviorTypesAvail: this.props.ListTresholdBehaviorTypesAvail, ListBonusLevelsAvail: this.props.ListBonusLevelsAvail, dataBrandGamesGwsSegmentation: this.props.dataBrandGamesGwsSegmentation, BrandsPayProvidersList: this.props.BrandsPayProvidersList, BrandsAutoWithdrawsList: this.props.BrandsAutoWithdrawsList, BrandsBlackIpList: this.props.BrandsBlackIpList, dlgWhiteIpEditor: this.props.dlgWhiteIpEditor, dlgDescriptionEditor: this.props.dlgDescriptionEditor, listAvailAppPayoutKeyVals: this.props.listAvailAppPayoutKeyVals, dlgKeyValueEditor: this.props.dlgKeyValueEditor, ListBrandAppPayoutTypesAvail: this.props.ListBrandAppPayoutTypesAvail, trust_zones_avail: this.state.trust_zones_avail, brandMessageTemplates: this.props.brandMessageTemplates, ListMessageActionsAvail: this.props.ListMessageActionsAvail, BrandsPayProvidersByTrustZonesList: this.props.BrandsPayProvidersTrustZonesList, trust_zones: this.state.app_trust_zones, ListBrandPayProvidersAvail: this.props.ListBrandPayProvidersAvail }));
        }
        if (this.state.edit_mode === "SMTP-CONFIG") {
            return (React.createElement(BrandSmtpCfgEditor_1.default, { onGoBack: this.onGoBackClick.bind(this), record: this.state.record, state: this.props.state, data: this.props.dataSmtp }));
        }
        if (this.state.edit_mode === "SMS-CONFIG") {
            return (React.createElement(BrandSmsCfgEditor_1.default, { onGoBack: this.onGoBackClick.bind(this), record: this.state.record, state: this.props.state, data: this.props.dataSmsCfg, smsProvidersAvail: this.state.sms_providers_avail, dataRestrictions: this.props.BrandsSmsCfgRestrictionsList, DlgSmsRestrictionEditor: this.props.DlgSmsRestrictionEditor, listSmsTemplateActions: this.props.listSmsTemplateActions }));
        }
        if (this.state.edit_mode === "LOCALES-LIST") {
            return (React.createElement(BrandLocalisations_1.default, { onGoBackClick: this.onGoBackClick.bind(this), record: this.state.record, state: this.props.state, dataLocales: this.props.brandLocales, listAppLanguages: this.props.listAppLanguages }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(BrandsList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onAccessConfigClick: this.onAccessConfigClick.bind(this), onGatewaysConfigClick: this.onGatewaysConfigClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, onSMTPConfigClick: this.onSMTPConfigClick.bind(this), onLocalesListClick: this.onGoLocalesClick.bind(this), onSMSConfigClick: this.onSMSConfigClick.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PUBrandsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PUBrandsList.getPageDescription = function (state) {
        return {
            icon: "registered",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_main_brands + "-id",
            itemTitle: "Брэнды",
            route: routes_1.routes.page_main_brands,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PUBrandsList;
}(React.Component));
exports.default = PUBrandsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/PBrandsList.tsx
// module id = 1750
// module chunks = 0